module.exports = __webpack_public_path__ + "static/media/delay-icon.0a911bfe.svg";